import { render, staticRenderFns } from "./sys_deptRole.vue?vue&type=template&id=3efda64c&scoped=true"
import script from "./sys_deptRole.vue?vue&type=script&lang=js"
export * from "./sys_deptRole.vue?vue&type=script&lang=js"
import style0 from "./sys_deptRole.vue?vue&type=style&index=0&id=3efda64c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efda64c",
  null
  
)

export default component.exports